import { createReducer } from 'redux-act';

import Notification from '../../models/interfaces/Notification';
import { partialReplaceEntity, union } from '../../utils/entityUtils';
import { authenticationRequired } from '../actions/authentication/authenticationRequired';
import { logout } from '../actions/authentication/logout';
import { notificationsFetched } from '../actions/notification/fetchNotifications';
import { notificationShown } from '../actions/notification/notificationShown';

export type NotificationState = Notification[];

const defaultState: NotificationState = [];

const notificationReducer = createReducer<NotificationState>({}, defaultState);

notificationReducer.on(notificationsFetched, (state, { notifications }) => union(state, notifications));

notificationReducer.on(notificationShown, (state, { uuid }) => partialReplaceEntity(state, { uuid, wasShown: true }));

notificationReducer.on(logout, () => defaultState);

notificationReducer.on(authenticationRequired, () => defaultState);

export default notificationReducer;
